"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _reduce = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/reduce"));
var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/map"));
var _react = _interopRequireDefault(require("react"));
var _intl = require("@kyruus/intl");
var _styles = _interopRequireDefault(require("./styles"));
var _location = require("../../lib/location");
var _messages = _interopRequireDefault(require("../../lib/constants/messages"));
var _providerLocation = _interopRequireDefault(require("../ProviderLocation/provider-location"));
/* eslint-disable react/prop-types */
const ProviderLocations = _ref => {
  var _context;
  let {
    locations,
    searchSummary,
    track,
    provider,
    bookOnlineUrl,
    onClickShowAvailability,
    availabilityTilesMessages,
    shouldDisplayAvailability,
    availabilityLinkTarget,
    onTimeSlotsClick,
    onAvailabilityTilesLoaded,
    apptInfo,
    slots,
    slotsStatus,
    getLocationUrl,
    locationCallback,
    locationCTA
  } = _ref;
  const headers = (0, _location.getLocationHeadersForProvider)(locations);
  const availByLocId = slots && (0, _reduce.default)(slots).call(slots, (groupedSlots, slot) => {
    const {
      location_id
    } = slot;
    if (groupedSlots[location_id]) {
      groupedSlots[location_id].push(slot);
    } else {
      groupedSlots[location_id] = [slot];
    }
    return groupedSlots;
  }, {});
  const tableHeaderCreator = message => {
    if (message) {
      return /*#__PURE__*/_react.default.createElement("th", {
        scope: "col"
      }, /*#__PURE__*/_react.default.createElement(_intl.FormattedMessage, message));
    }
    return /*#__PURE__*/_react.default.createElement("th", {
      scope: "col"
    });
  };
  const locationComponents = (0, _map.default)(_context = (0, _location.getSortedLocations)(locations)).call(_context, location => {
    let locationAvail = null;
    if (availByLocId) {
      locationAvail = availByLocId[location.id] || [];
    }
    return /*#__PURE__*/_react.default.createElement(_providerLocation.default, {
      location: location,
      headers: headers,
      searchedLocation: searchSummary.location,
      track: track,
      key: location.external_id,
      onClickShowAvailability: onClickShowAvailability,
      availabilityTilesMessages: availabilityTilesMessages,
      provider: provider,
      bookOnlineUrl: bookOnlineUrl,
      shouldDisplayAvailability: shouldDisplayAvailability,
      availabilityLinkTarget: availabilityLinkTarget,
      onTimeSlotsClick: onTimeSlotsClick,
      onAvailabilityTilesLoaded: onAvailabilityTilesLoaded,
      apptInfo: apptInfo,
      availability: locationAvail,
      slotsStatus: slotsStatus,
      getLocationUrl: getLocationUrl,
      locationCallback: locationCallback,
      locationCTA: locationCTA
    });
  });
  return !!locations.length && /*#__PURE__*/_react.default.createElement(_styles.default, null, /*#__PURE__*/_react.default.createElement("thead", null, /*#__PURE__*/_react.default.createElement("tr", null, tableHeaderCreator(_messages.default.location), headers.phone ? tableHeaderCreator(_messages.default.phone) : tableHeaderCreator(''), headers.distance ? tableHeaderCreator(_messages.default.distance) : tableHeaderCreator(''), locationCTA ? tableHeaderCreator(_messages.default.action) : tableHeaderCreator(''))), /*#__PURE__*/_react.default.createElement("tbody", null, locationComponents));
};
/* eslint-enable react/prop-types */
var _default = exports.default = ProviderLocations;
ProviderLocations.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "ProviderLocations"
};